/*global jQuery */
import './style.scss';

const addSearchToNavigation = function()
{
    "use strict";
    let $primary_menu = jQuery('.primary-navigation > ul')
        ,searchTriggerHTML  = "<li id=\"search-trigger\" class=\"menu-item menu-item-search-trigger\"><button><span class=\"sr-only\">Search the shop</span><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button></li>";

    $primary_menu.append( searchTriggerHTML );
};

const searchOverlayTrigger = function()
{
    "use strict";
    let $overlay= jQuery('.search-overlay-wrapper')
        ,$body  = jQuery('body');

    jQuery('#search-trigger button').on('click', event => {
        event.preventDefault();
        $overlay.addClass('active');
        $body.addClass('overlay-active');

        // Focus on the input field
        jQuery('.search-field').focus();
    });

    jQuery('#search-overlay-close-trigger').on('click', event => {
        event.preventDefault();
        $overlay.removeClass('active');
        $body.removeClass('overlay-active');
    });

    jQuery(document).on('keyup', event => {
      if (event.keyCode == 27) { // escape key maps to keycode '27'
        $overlay.removeClass('active');
        $body.removeClass('overlay-active');
      }
    });
};

export default (
	{
		addSearchToNavigation,
		searchOverlayTrigger
	}
)



// WEBPACK FOOTER //
// ./front-end/src/search/index.js